export default abstract class RegexLibrary {

  public static email    = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	public static password = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
	public static float = /^(\d+(?:[\.\,]\d{1,2})?)$/;
	public static onlyNumbers = /^[0-9]*$/;
	public static replaceOnlyNumbers = /[^0-9]/g;
	public static textNumberSpaceLine = /[^A-Za-z0-9\s-._]/g;

}